import { render, staticRenderFns } from "./CustomerDialog.vue?vue&type=template&id=15137150&scoped=true&"
import script from "./CustomerDialog.vue?vue&type=script&lang=ts&"
export * from "./CustomerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDialog.vue?vue&type=style&index=0&id=15137150&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15137150",
  null
  
)

export default component.exports